<template>
  <div>
    <schedule-table :items="items" :headers="headers" type="family" :users="users"/>
  </div>
</template>

<script>
  import scheduleTable from "./scheduleTable";
  export default {
    name: "mySchedule",
    components:{
      scheduleTable
    },
    data () {
      return {
        headers: [
          {
            text: this.$t('Day'),
            align: 'start',
            value: 'dayNameName',
            sortable: false
          },
          { text: this.$t('Name'), value: 'name',sortable: false },
          { text: this.$t('Type'), value: 'reservationTypeName',sortable: false },
          { text: this.$t('Sport'), value: 'sportActivityName',sortable: false },
          { text: this.$t('From'), value: 'fromTime',sortable: false },
          { text: this.$t('To'), value: 'toTime',sortable: false },
          { text: 'Actions', value: 'actions',sortable: false},
        ],
        items: [],
        users:[this.$t('All')]
      }
    },
    mounted() {
      this.getSchedulesMember()
    },
    methods: {
      getSchedulesMember() {
        this.$http_sys.post('/Schedule/GetScheduleFamily', {
          lang: this.$i18n.locale
        })
          .then(res => {
            this.items = []
            for (let i=0;i<res.data.length;i++){
              for (let j=0;j<res.data[i].children.length;j++) {
                this.users.push(res.data[i].fullName)
                res.data[i].children[j].name = res.data[i].fullName
                this.items.push(res.data[i].children[j])

              }
            }
          })
          .catch(error => {

          })
      },
    },

    computed: {
    },

    watch: {

    },
  }
</script>

<style scoped>

</style>
